import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from 'src/app/services/authentication-service/authentication.service';
import { UserService } from 'src/app/services/user-service/user.service';
import { Location } from '@angular/common';
import { RoleService } from 'src/app/services/role.service';
import { ThemeService } from 'src/app/services/theme.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit {
  email: string;
  privs = [];
  isDarkTheme = false;

  constructor(
    private authService: AuthenticationService, 
    public location: Location,
    private userService: UserService,
    private roleService: RoleService,
    public themeService: ThemeService,
    private cookie: CookieService,
    ) { }

  ngOnInit() {
    this.themeService.darkTheme.subscribe((isDarkTheme) => (this.isDarkTheme = isDarkTheme));

    // Initially check if dark mode is enabled on system
    const darkModeOn = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;

    // If dark mode is enabled then directly switch to the dark-theme
    if (darkModeOn) {
      this.themeService.setTheme(darkModeOn);
    }
    // Watch for changes of the preference
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (e) => {
      this.themeService.setTheme(true);
    });

    this.isDarkTheme = this.cookie.get('EDASH_DARK_THEME') === 'true';
    this.themeService.setTheme(this.isDarkTheme);

    this.themeService.darkTheme.subscribe((isDarkTheme) => this.isDarkTheme = isDarkTheme);
    // On login state change, check privs
    this.authService.authenticationState.subscribe(() => {
      const user = this.userService.getUser();
      if (user) {
        
        this.email = user.email;
        this.privs = this.userService.getUser().roles;
      }
    });

    if (this.userService.getToken()) {
      this.email = this.userService.getUser().email;    
    }
    
  }

  checkRole(role: string) {
    return this.roleService.checkRole(role);
  }

  toggleTheme() {
    this.themeService.toggleDarkTheme();
  }

  checkValidPath() {
    return !(this.location.path().includes('/login') ||
      this.location.path().includes('/reset-password'));
  }

  logout() {
    this.authService.logout();
  }
}
